<template>
  <div class="not-found">
    <span class="not-found__error-code">
      404
    </span>
    <span class="not-found__title">
      {{ $t('thePageDoesNotExist') }}
    </span>
    <p class="not-found__description" v-html="$t('notFoundDescription')" />
    <router-link class="not-found__homepage-link" :to="{ name: 'home' }">
      {{ $t('backToHomePage') }}
    </router-link>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import store from '@/store/index';


  export default {
    name: 'Error404',
    metaInfo () {
      const {companyInfo, $t } = this;
      return {
        title: $t('thePageDoesNotExist') + ' | ' + companyInfo.seo_title + ' | ' + $t('titleWindowConfigurator'),
      }
    },
    computed: {
      ...mapState({
        companyInfo: state => state.companyInfo,
      }),
    },
  };
</script>
